// Figma „Badge Pill“ mit Rahmen — v2-Badge hat keine Outline-Variante
export const qualifikationBadgeClassName =
  'max-w-full min-w-0 shrink-0 border border-neutrals-v2-300 bg-transparent text-labels-secondary';
